import { render, staticRenderFns } from "./BirdDogBonusTotal.vue?vue&type=template&id=45989159&scoped=true&"
import script from "./BirdDogBonusTotal.vue?vue&type=script&lang=js&"
export * from "./BirdDogBonusTotal.vue?vue&type=script&lang=js&"
import style0 from "./BirdDogBonusTotal.vue?vue&type=style&index=0&id=45989159&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45989159",
  null
  
)

export default component.exports